import { MessageCircleQuestion, MessagesSquare } from "lucide-react";
import { Markdown } from "./Markdown";
import { SpeakButton } from "./SpeakButton";
import { MODELS } from "../lib/models";

const ROUND_LABEL = { 1: "My view", 2: "Answering back" };

const Bubble = ({ msg, part, index, chatId, live, kids }) => {
  const m = MODELS.find((x) => x.key === msg.model) || MODELS[0];
  return (
    <div data-testid={`kids-debate-msg-${part}`} className="what-kid-bubble" style={{ "--c": m.color }}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <span className="flex items-center gap-2 text-sm font-semibold" style={{ color: m.color }}>
          <span className="what-kid-avatar" style={{ background: m.color }}>{m.name[0]}</span>
          {m.name}
          <span className="hidden sm:inline text-xs font-mono text-slate-500 whitespace-nowrap">· {ROUND_LABEL[msg.round] || "Thinking"}</span>
        </span>
        {chatId && !live && <SpeakButton chatId={chatId} index={index} part={part} big={kids} testid={`kids-debate-listen-${part}`} />}
      </div>
      <Markdown testid={`kids-debate-text-${part}`} words={kids ? msg.hard_words : undefined}>{msg.text}</Markdown>
    </div>
  );
};

export const KidsDebate = ({ turn, index, chatId }) => {
  const msgs = turn.kids_debate || [];
  if (!msgs.length) return null;
  return (
    <div data-testid="kids-debate-panel" className="mt-6 space-y-4">
      <p className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.16em] text-[#A78BFA]">
        <MessagesSquare size={13} /> The AIs debate with you
      </p>
      {msgs.map((msg, i) => <Bubble key={i} msg={msg} part={i} index={index} chatId={chatId} live={turn.live} kids={turn.kids} />)}
    </div>
  );
};

const MODES = [
  [false, "ask", "Ask a question", "Ask", MessageCircleQuestion],
  [true, "debate", "Debate with the AIs", "Debate", MessagesSquare],
];

export const DebateToggle = ({ on, setOn, disabled }) => (
  <div data-testid="mode-switch" role="radiogroup" aria-label="How do you want to talk to the AIs?" className="what-mode-switch">
    {MODES.map(([value, id, label, short, Icon]) => (
      <button
        key={id}
        type="button"
        role="radio"
        aria-checked={on === value}
        data-testid={`mode-${id}-btn`}
        disabled={disabled}
        onClick={() => setOn(value)}
        className={`what-mode-btn ${on === value ? "is-on" : ""} ${value ? "is-debate" : ""}`}
      >
        <Icon size={15} /> <span className="hidden sm:inline">{label}</span><span className="sm:hidden">{short}</span>
      </button>
    ))}
  </div>
);
